import type { ThemeSpec } from '../themes';

export function renderBackground(ctx: CanvasRenderingContext2D, theme: ThemeSpec, w: number, h: number) {
  ctx.save();
  ctx.fillStyle = theme.bgColor;
  ctx.fillRect(0, 0, w, h);
  ctx.restore();
}

/**
 * 木质黑板框 —— 画在**笔画层之上**（前景）。
 * 以前画在背景层：放大后内容超出屏幕，笔画直接"盖到木框上"，观感很怪。
 * 挪到最上层后框永远完整（真实黑板语义：粉笔延伸到框后面被挡住），
 * 绘制本身只是 4 个渐变矩形 + 一条描边，RAF 每帧画一次成本可忽略。
 */
export function renderWoodFrame(ctx: CanvasRenderingContext2D, _theme: ThemeSpec, w: number, h: number) {
  const f = 28;
  ctx.save();
  const top = ctx.createLinearGradient(0, 0, 0, f);
  top.addColorStop(0, '#6a4620');
  top.addColorStop(0.5, '#4a2f12');
  top.addColorStop(1, '#2f1e0b');
  ctx.fillStyle = top;
  ctx.fillRect(0, 0, w, f);
  ctx.fillRect(0, h - f, w, f);

  const side = ctx.createLinearGradient(0, 0, f, 0);
  side.addColorStop(0, '#6a4620');
  side.addColorStop(0.5, '#4a2f12');
  side.addColorStop(1, '#2f1e0b');
  ctx.fillStyle = side;
  ctx.fillRect(0, 0, f, h);
  ctx.fillRect(w - f, 0, f, h);

  ctx.strokeStyle = 'rgba(0,0,0,0.35)';
  ctx.lineWidth = 1;
  ctx.strokeRect(f - 0.5, f - 0.5, w - f * 2 + 1, h - f * 2 + 1);
  ctx.restore();
}
